import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CandidatoEnviarArquivoComponent } from './pages/candidato/candidato-enviar-arquivo/candidato-enviar-arquivo.component';
import { RecuperarSenhaComponent } from './pages/login/senha/recuperar-senha.component';
import { CandidatoConvocadoComponent } from './pages/candidato-convocado/candidato-convocado.component';
import { DesistirConvocacaoComponent } from './pages/candidato-convocado/desistir/desistir-convocacao.component';
import { DadosAdicionaisComponent } from './pages/candidato-convocado/dadosAdicionais/dados-adicionais.component';
import { DeclaracaoAcumuloCargoComponent } from './pages/candidato-convocado/acumuloCargo/declaracaoAcumuloCargo.component';

const routes: Routes = [

  { path: 'home', component: HomeComponent },
  { path: 'edital', loadChildren: 'app/pages/edital/edital.module#EditalModule' },
  { path: 'login-internet', loadChildren: 'app/pages/login-internet/login-internet.module#LoginInternetModule' },
  { path: 'candidato', loadChildren: 'app/pages/candidato/candidato.module#CandidatoModule' },

  { path: 'convocacao', loadChildren: 'app/pages/convocacao/convocacao.module#ConvocacaoModule' },
  { path: 'avaliacao', loadChildren: 'app/pages/avaliacao/avaliacao.module#AvaliacaoModule' },
  { path: 'avaliacao-deficiente', loadChildren: 'app/pages/avaliacao-deficiente/avaliacao-deficiente.module#AvaliacaoDeficienteModule' },

  { path: 'servidor', loadChildren: 'app/pages/servidor/servidor.module#ServidorModule' },

  { path: 'processar-classificacao', loadChildren: 'app/pages/processar-classificacao/processar-classificacao.module#ProcessarClassificacaoModule' },

  { path: 'login', loadChildren: 'app/pages/login/login.module#LoginModule' },

  { path: 'alterar-senha', loadChildren: 'app/pages/alterar-senha/alterar-senha.module#AlterarSenhaModule' },

  { path: 'publicar-arquivo', loadChildren: 'app/pages/publicar-arquivo/publicar-arquivo.module#PublicarArquivoModule' },

  { path: "candidato-enviar-arquivo", component: CandidatoEnviarArquivoComponent },
  { path: "candidato-convocado", component: CandidatoConvocadoComponent },
  { path: "desistir-convocacao", component: DesistirConvocacaoComponent},
  { path: "dados-adicionais", component: DadosAdicionaisComponent},
  { path: "declaracao-acumulo-cargo", component: DeclaracaoAcumuloCargoComponent},
  
  { path: "login-recuperar-senha", component: RecuperarSenhaComponent },

  { path: '**', redirectTo: 'home', pathMatch: 'full' },

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts